// extracted by mini-css-extract-plugin
module.exports = {"iconButton":"_-ui-admin-lib-IconButton-index-module__iconButton--1h4H0","icon":"_-ui-admin-lib-IconButton-index-module__icon--3oESt"};